import { isPlainObject } from "lodash"

interface IAttrs {
  [key: string]: string
}

export function getHTMLAttributesJson(el: HTMLElement) {
  if (!(el instanceof HTMLElement)) return {}
  return Object.fromEntries(
    Array.from(el.attributes)
      .map((attribute) => {
        return [attribute.name, el.getAttribute(attribute.name)]
      })
  )
}

export function getHTMLAttributeJsonToString(attrs: IAttrs) {
  if (!isPlainObject(attrs)) return ''
  return Object.entries(attrs).map(([key, value]) => `${key}="${value}"`).join(" ")
}

export const isNotFormattedElement = (node)=>{
  return node.nodeName === 'PRE' || node.nodeName === 'SCRIPT';
}

export const removeIndexFromCSSString = (cssString: string): string => {
  const declarations = cssString.split(';');
  const indexAccessPattern = /^\d+$/;
  let newCssString = ""
  for (let declaration of declarations) {
    if(!declaration) continue;
    // Remove any extra whitespace
    let [property, ...valueParts] = declaration.split(':');
    const value = valueParts.join(':').trim();
    property = property.trim();
    if (!property || !value) continue;
    if (indexAccessPattern.test(property)) continue;
    
    newCssString += `${property}:${value};`
  }
  return newCssString;
}

